import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/faq/de/og.png';
import { Faq } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Faq/faq__en-DE.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

type FaqItem = { question: string; answer: string };
const faqItems = (content as unknown as { faqItems: FaqItem[] }).faqItems || [];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item: FaqItem) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-DE'].layout },
  seo: {
    title: 'Contents & Personal Liability Insurance FAQ | Lemonade',
    metaTitle: 'Contents & Personal Liability Insurance FAQ | Lemonade',
    description:
      "Insurance can be confusing, but it doesn't have to be!! Here are some of Lemonade's top FAQs - from what renters insurance is, You'll also learn a bit more about extra coverage and Lemonade's business model.",
    jsonld: [faqSchema],
    ogImage: ogImage.src,
  },
  MDXContent: content as Faq,
};
